import React, { useState } from 'react';
import { Car, Lock, AlertCircle } from 'lucide-react';

export function LoginScreen({ t, onLogin, isValidating, error }) {
  const [token, setToken] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (token.trim()) {
      await onLogin(token.trim());
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900 text-white flex items-center justify-center px-4">
      <div className="w-full max-w-md">
        {/* Logo & Branding */}
        <div className="text-center mb-8">
          <div className="flex items-center justify-center gap-3 mb-4">
            <Car className="w-12 h-12 text-emerald-400" />
            <h1 className="text-4xl font-bold">Arbauto</h1>
            <span className="px-3 py-1 text-xs font-semibold uppercase tracking-wider bg-amber-500/20 text-amber-400 border border-amber-500/30 rounded-full">
              Beta
            </span>
          </div>
          <p className="text-slate-400 text-sm">
            {t('loginTagline')}
          </p>
        </div>

        {/* Login Card */}
        <div className="bg-slate-800 rounded-2xl border border-slate-700 p-8 shadow-2xl shadow-black/20">
          <h2 className="text-xl font-semibold mb-6 text-center">
            {t('loginTitle')}
          </h2>

          <form onSubmit={handleSubmit} className="space-y-5">
            <div>
              <label htmlFor="access-code" className="block text-sm font-medium text-slate-300 mb-2">
                {t('accessCodeLabel')}
              </label>
              <div className="relative">
                <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                  <Lock className="w-5 h-5 text-slate-500" />
                </div>
                <input
                  id="access-code"
                  type="password"
                  value={token}
                  onChange={(e) => setToken(e.target.value)}
                  placeholder={t('accessCodePlaceholder')}
                  disabled={isValidating}
                  className="w-full bg-slate-900 border border-slate-600 rounded-lg pl-10 pr-4 py-3 text-white placeholder-slate-500 focus:ring-2 focus:ring-emerald-500 focus:border-transparent outline-none disabled:opacity-50 disabled:cursor-not-allowed transition-all"
                  autoFocus
                />
              </div>
            </div>

            {error && (
              <div className="flex items-start gap-2 p-3 bg-red-500/10 border border-red-500/30 rounded-lg">
                <AlertCircle className="w-5 h-5 text-red-400 shrink-0 mt-0.5" />
                <p className="text-sm text-red-400">{t(`loginError_${error}`) !== `loginError_${error}` ? t(`loginError_${error}`) : error}</p>
              </div>
            )}

            <button
              type="submit"
              disabled={isValidating || !token.trim()}
              className="w-full bg-emerald-500 hover:bg-emerald-600 disabled:opacity-50 disabled:cursor-not-allowed px-4 py-3 rounded-lg font-semibold transition-colors"
            >
              {isValidating ? t('validating') : t('loginButton')}
            </button>
          </form>

          <div className="mt-6 pt-6 border-t border-slate-700">
            <p className="text-xs text-slate-500 text-center">
              {t('loginFooter')}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default LoginScreen;
